import { CombinedVueInstance } from 'vue/types/vue';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import PopupComponent from '@/components/messageBox/popup';

@Component({
    template: `<MyPopup v-model="value" class="market-popup" :content-class="['center-popup']" position="center">
        <img class="image" v-thumbnail="'/meta/market/20190718/college_popup.jpg'" />
        <div class="btn-wrap">
            <MobileButton name="primary"
                class="btn-large btn-round"
                @click="onClickImage">
                报名听课
            </MobileButton>
        </div>
        <i class="icon" @click="onClickClose">&#xe60b;</i>
    </MyPopup>`,
})
export class MarketPopup extends Mixins(PopupComponent) {
    /**
     * 关闭
     */
    public onClickClose() {
        this.value = false;
    }

    public onClickImage() {
        location.href = 'https://m.qlchat.com/wechat/page/topic-intro?topicId=2000004790800969';
    }
}

export type MarketPopupComponent = CombinedVueInstance<MarketPopup, object, object, object, Record<keyof object, any>>;
